import { StripePaymentStatus } from "@shared_packages/toolkit/types";
import {
  ISearchFieldConfig,
  SearchFieldType,
} from "../../../../components/advanced-search/AdvancedSearch.interface";
import { directDebitConsentDropdownValues } from "../constants/directDebitConsentFilter";
import { testCompanyScopeDropdownValues } from "../constants/testCompanyScope";
import {
  businessTypeField,
  countryField,
} from "../constants/companyFilterFields";

export const companySearchConfig: ISearchFieldConfig[] = [
  {
    type: SearchFieldType.DROPDOWN,
    label: "Test companies filter",
    key: "testCompanyScope",
    dropdownValues: testCompanyScopeDropdownValues,
  },
  {
    type: SearchFieldType.DATE_RANGE,
    label: "Created date",
    key: "from",
    rangeEndKey: "to",
    placeholder: "From",
    rangeEndPlaceholder: "To",
  },
  businessTypeField,
  countryField,
  {
    type: SearchFieldType.DROPDOWN,
    label: "Direct debit consent",
    key: "directDebitConsent",
    dropdownValues: directDebitConsentDropdownValues,
  },
  {
    type: SearchFieldType.DROPDOWN,
    label: "Stripe Connect Status",
    key: "stripePaymentStatus",
    dropdownValues: [
      { label: "All", value: "" },
      { label: "Requested", value: StripePaymentStatus.REQUESTED },
      { label: "Enabled", value: StripePaymentStatus.ENABLED },
      { label: "Disabled", value: StripePaymentStatus.DISABLED },
    ],
  },
  {
    type: SearchFieldType.DROPDOWN,
    label: "Partner",
    key: "canManageCompanies",
    dropdownValues: [
      { label: "All", value: "" },
      { label: "Yes", value: "true" },
      { label: "No", value: "false" },
    ],
  },
  {
    type: SearchFieldType.SEARCH_BY_USER_DROPDOWN,
    label: "Search by owner",
    key: "createdBy",
  },
];
